import * as Sentry from '@sentry/nextjs'

interface SettingsErrorReporterOptionsI {
  feature: string
  surface: string
}

export const createSettingsErrorReporter =
  ({ feature, surface }: SettingsErrorReporterOptionsI) =>
  (error: unknown, action: string) => {
    Sentry.captureException(error, {
      tags: {
        action,
        feature,
        surface,
      },
    })
  }
